import _ from 'lodash'

import { arrayHasSameElements } from '@/shared/lib/array/has-same-elements'

import { LevelPlayMosaic as Activity } from '.'

export const SLUG = 'mosaic'
export const activity = {
  SLUG,
  Component: Activity,
  handleAnswerCallback: props => {
    let { answer, activity } = props
    let { save_answer: saveAnswer, images = [] } = activity.meta
    const correctImagesIds = images
      .filter(image => image?.is_correct)
      .map(image => image.image_id)

    let answerIsCorrect = arrayHasSameElements(correctImagesIds, answer)

    return { answer, answerIsCorrect, skipValidation: saveAnswer }
  }
}
